<template>
  <div class="flex flex-col h-screen">
    <div class="md:px-16 py-8 sticky top-0 bg-white border-b border-opacity-50">
      <header class="flex items-center justify-between">
        <div class="flex items-center gap-4">
          <h1 class="text-2xl font-bold">OpenCDLJobs</h1>
          <span>|</span>
          <small class="uppercase">company</small>
        </div>
        <div class="flex justify-center gap-8">
          <div class="flex items-center space-x-2">
            <div
              class="
                w-[45px]
                h-[45px]
                rounded-full
                bg-gray-500
                border-4 border-gray-200
                overflow-hidden
              "
            ></div>
            <span class="text-sm font-medium">{{ recruiter.name }}</span>
          </div>
          <button
            type="button"
            @click="logout"
            class="
              bg-gray-700
              text-white
              px-4
              rounded
              tracking-wide
              text-sm
              hover:bg-gray-200 hover:text-gray-900
            "
          >
            Logout
          </button>
        </div>
      </header>
    </div>

    <div
      class="w-full mx-auto py-6 md:grid md:grid-cols-12 md:gap-x-5 md:px-16"
    >
      <aside class="px-2 sm:px-6 md:py-0 md:px-0 md:col-span-2">
        <nav class="space-y-2 border-l">
          <Link
            v-for="item in navigation"
            :key="item.name"
            :href="item.href"
            :class="[
              $page.url.substring(11).startsWith(item.baseUrl)
              // item.component === $page.component
                ? 'bg-gray-50 text-blue-700 hover:text-blue-700 hover:bg-white rounded-none border-l-4  -ml-0.5 text-xs tracking-wider border-blue-500'
                : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50',
              'group rounded-md px-3 py-2 flex items-center text-sm font-normal',
            ]"
            :aria-current="
              item.component === $page.component ? 'page' : undefined
            "
          >
            <component
              :is="item.icon"
              :class="[
                item.component === $page.component
                  ? 'text-blue-500 group-hover:text-blue-500'
                  : 'text-gray-400 group-hover:text-gray-500',
                'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
              ]"
              aria-hidden="true"
            />
            <span class="truncate">
              {{ item.name }}
            </span>
          </Link>
        </nav>
      </aside>
      <div class="sm:px-6 md:px-0 md:col-span-10">
        <slot />
      </div>
    </div>
    <div
      class="
        w-full
        h-16
        flex
        items-center
        bg-white
        border-t border-opacity-50
        fixed
        bottom-0
        md:px-16
      "
    >
      <div class="flex items-center gap-4">
        <h1 class="text-sm font-semibold tracking-wider">OpenCDLJobs.com</h1>
        <span>|</span>
        <small>2022</small>
      </div>
    </div>

    <FlashMessage />
  </div>
</template>

  <script setup>
import FlashMessage from "@/components/FlashMessage.vue";

import {
  AdjustmentsIcon,
  BriefcaseIcon,
  OfficeBuildingIcon,
  KeyIcon,
  CreditCardIcon,
} from "@heroicons/vue/outline";
import { Inertia } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-vue3";
import { computed } from "@vue/reactivity";

const props = defineProps({
  authRecruiter: Object,
});

const route = window.route;

const recruiter = computed(() => {
  return props.authRecruiter;
});

const logout = () => {
  Inertia.post(route("recruiter.logout"));
};

const navigation = [
  {
    name: "Dashboard",
    href: route("recruiter.home"),
    icon: AdjustmentsIcon,
    component: "Recruiters/Home",
    baseUrl: "recruiters",
  },
  {
    name: "Company Profile",
    href: route("recruiter.profile"),
    icon: OfficeBuildingIcon,
    component: "Recruiters/Profile",
    baseUrl: "/profile",
  },
  {
    name: "Jobs",
    href: route("recruiter.jobs"),
    icon: BriefcaseIcon,
    component: "Recruiters/Jobs",
    baseUrl: "/jobs"

  },
  {
    name: "Subscriptions",
    href: route("recruiter.home"),
    icon: CreditCardIcon,
    component: "false",
  },
  {
    name: "Account Security",
    href: route("recruiter.home"),
    icon: KeyIcon,
    component: "false",
  },
];
</script>
